import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PillComponent } from '@/app/shared/pill/pill.component';
import { ProjectDetails } from '@/app/interfaces/project';
import { ReviewFieldsService } from '@/app/services/ia-services/review-fields.service';
import { ReviewFieldKey } from '@/app/interfaces/review-fields.types';
import { TooltipComponent } from '@/app/shared/tooltip/tooltip.component';
@Component({
  selector: 'app-project-functional-data',
  standalone: true,
  imports: [CommonModule, PillComponent, TooltipComponent],
  templateUrl: './project-functional-data.component.html',
})
export class ProjectFunctionalDataComponent {
  @Input() project: ProjectDetails | null = null;
  @Input() reviewMode = false;
  @Input() readonlyReview = false;
  @Input() showPreviousReviewIndicators = false;
  constructor(public reviewFields: ReviewFieldsService) {}
  previousReviewText(fieldKey: ReviewFieldKey): string {
    return this.reviewFields.getPreviousReviewTooltipText(fieldKey);
  }
}
